export const startupMaturityList: Array<string> = ['待定', 'R0', 'R1', 'R2', 'R3', 'R4', 'R5'];
export const CEOSuitabilityList: Array<string> = ['待定', 'S', 'A', 'A-', 'B+', 'B', 'KP'];
export const maintenanceStrategyList: Array<string> = ['待定', 'P0', 'P1', 'P2', 'P3'];

export const kpSeedColumns = [
  {
    title: '客户姓名',
    fixed: 'left',
    width: '120px',
    dataIndex: 'baseInfo',
    key: 'name',
    align: 'center',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '负责人',
    width: '180px',
    dataIndex: 'maintainer',
    key: 'maintainer',
    align: 'left',

    customRender: (e, row, index) => {
      let name = e.value ? e.value.nickname : '';
      let nameAid = row.maintainerAid && row.maintainerAid.value ? '、' + row.maintainerAid.value.map(_ => _.nickname).join('、') : '';
      return {
        children: name + nameAid
      };
    }
  },
  // {
  //   title: '辅负责人',
  //   width: '120px',
  //   dataIndex: 'maintainerAid',
  //   key: 'maintainerAid',
  //   align: 'center',
  //   scopedSlots: { customRender: 'maintainerAid' },
  //   customRender: e => {
  //     return {
  //       children: e.value ? e.value.map(_ => _.nickname).join('、') : ''
  //     };
  //   }
  // },
  {
    title: '创业状态成熟度',
    width: '100px',
    dataIndex: 'startupMaturity',
    key: 'startupMaturity',
    align: 'center',
    customRender: e => {
      return {
        children: e ? e.value : ''
      };
    }
  },
  {
    title: 'DL评级',
    width: '100px',
    dataIndex: 'CEOSuitability',
    key: 'CEOSuitability',
    align: 'center',
    customRender: e => {
      return {
        children: e ? e.value : ''
      };
    }
  },
  {
    title: '维护策略',
    width: '100px',
    dataIndex: 'maintenanceStrategy',
    key: 'maintenanceStrategy',
    align: 'center',
    customRender: e => {
      return {
        children: e ? e.value : ''
      };
    }
  },
  {
    title: '近期动态',
    // width: '350px',
    key: 'latestDevelopment',
    align: 'left',
    scopedSlots: { customRender: 'latestDevelopment' }
  },
  {
    title: '教育经历',
    width: '200px',
    dataIndex: 'educationExperience',
    key: 'educationExperience',
    align: 'left',
    scopedSlots: { customRender: 'educationExperience' }
  },
  {
    title: '工作经历',
    width: '200px',
    dataIndex: 'workExperience',
    key: 'workExperience',
    align: 'left',
    scopedSlots: { customRender: 'workExperience' }
  },
  {
    title: '个人特质',
    width: '200px',
    dataIndex: 'individuality',
    key: 'individuality',
    align: 'left',
    scopedSlots: { customRender: 'individuality' }
  },
  {
    title: '操作',
    key: 'action',
    width: '150px',
    align: 'center',
    scopedSlots: {
      customRender: 'action'
    },
    fixed: 'right'
  }
];

export const orderByList: any[] = [
  {
    name: '跟进时间 由近及远',
    value: 1
  },
  {
    name: '提交时间 由近及远',
    value: 2
  },
  {
    name: '优先级 从高到低',
    value: 3
  }
];

export const statusList: any[] = [
  {
    name: '继续跟进',
    value: 2
  },
  {
    name: '暂不跟进',
    value: 1
  }
];

export const sectorList: any[] = [
  {
    name: '全部',
    value: -1
  },
  { name: '消费', value: '消费' },
  { name: '企业服务', value: '企业服务' },
  { name: '元宇宙', value: '元宇宙' },
  { name: '产业数字化', value: '产业数字化' },
  { name: '人工智能', value: '人工智能' },
  { name: '生物医疗', value: '生物医疗' },
  { name: '智能制造', value: '智能制造' },
  { name: '半导体', value: '半导体' },
  { name: '新能源', value: '新能源' },
  { name: 'Web3', value: 'Web3' },
  { name: '其他', value: '其他' },
  { name: '暂无', value: 0 }
];

export const priorityList: any[] = [
  { name: 'P0', value: 0 },
  { name: 'P1', value: 1 },
  { name: 'P2', value: 2 },
  { name: 'P3', value: 3 }
];

const bpSeedColumns: any[] = [
  {
    title: '姓名',
    fixed: 'left',
    width: '120px',
    dataIndex: 'name',
    key: 'name',
    align: 'center'
  },
  {
    title: '联系方式',
    width: '150px',
    dataIndex: 'code',
    key: 'code',
    align: 'left'
  },
  {
    title: '视频',
    width: '200px',
    key: 'video',
    align: 'center',
    scopedSlots: { customRender: 'video' }
  },
  {
    title: '商业计划书',
    width: '200px',
    key: 'bp',
    align: 'center',
    scopedSlots: { customRender: 'bp' }
  },
  {
    title: '领域',
    width: '100px',
    dataIndex: 'sector',
    key: 'sector',
    align: 'center'
  },
  {
    title: '其他说明',
    width: '300px',
    key: 'content',
    align: 'left',
    scopedSlots: { customRender: 'content' }
  },
  {
    title: '文件',
    width: '200px',
    key: 'files',
    align: 'left',
    scopedSlots: { customRender: 'files' }
  },
  {
    title: '邮箱',
    width: '200px',
    dataIndex: 'mail',
    key: 'mail',
    align: 'left'
  },
  {
    title: '提交时间',
    width: '120px',
    dataIndex: 'createAt',
    key: 'createAt',
    align: 'left'
  }
];

export const bpSeedColumnsUnresolved = bpSeedColumns.concat([
  {
    title: '负责人',
    dataIndex: 'manager',
    width: '100px',
    align: 'center'
  },
  {
    title: '操作',
    key: 'action',
    width: '100px',
    align: 'center',
    scopedSlots: {
      customRender: 'action'
    },
    fixed: 'right'
  }
]);

export const kpProjectColumns = [
  {
    title: '核心人员姓名',
    fixed: 'left',
    width: '150px',
    dataIndex: 'baseInfo',
    key: 'name',
    align: 'center',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '职位',
    width: '120px',
    dataIndex: 'position',
    key: 'position',
    align: 'center',
    customRender: e => {
      return {
        children: e ? e.value : ''
      };
    }
  },
  {
    title: '教育经历',
    width: '300px',
    dataIndex: 'educationExperience',
    key: 'educationExperience',
    align: 'left',
    scopedSlots: { customRender: 'educationExperience' }
  },
  {
    title: '工作经历',
    width: '300px',
    dataIndex: 'workExperience',
    key: 'workExperience',
    align: 'left',
    scopedSlots: { customRender: 'workExperience' }
  },
  {
    title: '个人特质',
    width: '300px',
    dataIndex: 'individuality',
    key: 'individuality',
    align: 'left',
    scopedSlots: { customRender: 'individuality' }
  },
  {
    title: '近期动态',
    width: '400px',
    key: 'latestDevelopment',
    align: 'left',
    scopedSlots: { customRender: 'latestDevelopment' }
  },
  {
    title: '操作',
    key: 'action',
    width: '250px',
    align: 'center',
    scopedSlots: {
      customRender: 'action'
    },
    fixed: 'right'
  }
];

export const bpSeedColumnResolved = bpSeedColumns.concat([
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    width: '150px',
    align: 'center'
  },
  {
    title: '优先级',
    dataIndex: 'priority',
    key: 'priority',
    width: '150px',
    align: 'center'
  },
  {
    title: '说明',
    dataIndex: 'illustrate',
    key: 'illustrate',
    width: '150px',
    align: 'center'
  },
  {
    title: '负责人',
    dataIndex: 'manager',
    width: '100px',
    align: 'center'
  },
  {
    title: '跟进时间',
    dataIndex: 'updateAt',
    key: 'updateAt',
    width: '120px',
    align: 'center'
  },
  {
    title: '跟进人',
    dataIndex: 'updateBy',
    key: 'updateBy',
    width: '100px',
    align: 'center'
  }
]);
